import { render, staticRenderFns } from "./OrbsFilter.vue?vue&type=template&id=20f5ae92&scoped=true&"
import script from "./OrbsFilter.vue?vue&type=script&lang=js&"
export * from "./OrbsFilter.vue?vue&type=script&lang=js&"
import style0 from "./OrbsFilter.vue?vue&type=style&index=0&id=20f5ae92&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20f5ae92",
  null
  
)

export default component.exports